module.exports = __webpack_public_path__ + "img/zizhi9.b636ef12.jpg";